import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@univacity/angular/datas';
import { AngularUiModule } from '@univacity/angular/ui';
import { Organisation } from '@univacity/shared/types';

@Component({
  selector: 'un-card-action',
  imports: [RouterModule, AngularUiModule],
  templateUrl: './card-action.component.html',
  styleUrls: ['./card-action.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardActionComponent {
  @Input() showDeleteText: boolean;
  @Input() itemId: string;
  @Input() organisation?: string | Organisation;
  @Input() viewLink: string | string[];
  @Input() viewText: string = $localize`See Availability`;
  @Input() editLink: string | string[];
  @Input() cloneLink: string | string[];
  @Output() delete = new EventEmitter<void>();

  get organisationId() {
    return typeof this.organisation === 'string'
      ? this.organisation
      : this.organisation?._id;
  }
  constructor(public auth: AuthService) {}
}
